<template>
  <div class="col-12">
    <div class="row">
      <div class="col-2 input-group my-0 mx-0 px-0">
        <button type="button"
        @click="showFlag = true"
        class="btn btn-light  px-0 py-0 my-0 mx-0"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        >
          <img
          :src="flagActually"
          class="flag ml-2 mr-2"
          />
        </button>
        <div class="dropdown-menu dropdown-menu-left" v-if="countriesFiltered.length > 0">
          <button v-for="(country, i) of countriesFiltered.filter( e => e.visible)"
                class="dropdown-item"
                type="button"
                @click="changeCountry(country.id)"

                :key="i">
            <img
              :src="flag2(country.id)"
              class="flag2"
            />
            <span class="ml-2 small">+ {{ country.phone_code }} {{ country.name }}</span>
          </button>
          <div class="col-12 px-4 py-2">
            <span>Other country</span>
            <input class="my-1 border"
              placeholder="Your country..."
              type="text"
              v-model="filterCountry">
          </div>
          </div>
        </div>
      <div class="col-10 justify-content-end mx-0 px-0">
        <input
          ref="phone"
          id="phone"
          type="text"
          class="form-control"
          v-model="value"
          @input="changeInput"
          required="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { abstractField } from "vue-form-generator";
import { countriesService } from "@/_services";
export default {
  name: 'PhoneFlag',
  mixins: [ abstractField ],
  data() {
    return {
      isInputValid: false,
      codeIsNew: false,
      phone:'',
      countriesFiltered: [],
      filterCountry: null,
      flagActually: null,
      showFlag: true,
      optionsDefault: ['CA', 'ES', 'IT', 'GB', 'US', 'FR', 'DE'],
      countries: [],
      country_id: {
          "id": "73",
          "name": "France",
          "iso": "fr",
          "phone_code": "33",
          "visible": true
      },
      dynamicPhoneValue: '' // Agregar como reactivo
    };
  },
  created(){
    this.geCountries();
   if (this.schema && this.schema.fieldOptions) {
     this.dynamicPhoneValue = this.schema.fieldOptions.dynamicPhoneValue || '';
    } else {
      console.warn('Schema or fieldOptions is not defined at created');
    }
  },

  props: {
    phoneValue: {
      type: String,
      default: ''
    }
  },

  computed: {
    flag2(){
      return (countryId) => {
        const flag = this.countries.find( el => el.id === countryId).iso
        return require('@/assets/images/flags/' + flag +  '.svg' )
      }
    },
  },
  mounted() {
    this.value = '+33 '  
    // Si `fieldOptions` es necesario para otras partes del sistema
    if (!this.schema.fieldOptions) {
      this.schema.fieldOptions = {};
    }
    this.dynamicPhoneValue = this.schema.fieldOptions.dynamicPhoneValue || '';

  },
  watch:{
     dynamicPhoneValue: {
      handler(newValue) {
        const index = this.countriesFiltered.findIndex(e => e.phone_code == this.value.substr(1) && e.iso == newValue);  //
        if (index !== -1) {
          this.countriesFiltered[index].visible = true;
          this.country_id = this.countriesFiltered[index]          
        }   
      },
      deep: true,
      immediate: true,
    },
    filterCountry(newValue){
      this.countriesFiltered = this.countries.map( e => ({...e}))
      if(newValue.length > 2){
        this.countriesFiltered = this.countriesFiltered
                                  .filter( e => e.name.toUpperCase().includes(newValue.toUpperCase()))
        this.countriesFiltered.forEach( e => e.visible = true )
      }
    },
    country_id(newValue, oldValue){
      if(newValue.id === "3333") {
        this.flagActually = null
        return
      }
      const flag = this.countries.find( el => el.id === newValue.id).iso
      this.flagActually = require('@/assets/images/flags/' + flag +  '.svg' )
      this.showFlag = true
    },
    'schema.fieldOptions.dynamicPhoneValue': {
    handler(newValue) {
      if (newValue !== undefined) {
        this.dynamicPhoneValue = newValue;
      }
    },
    deep: true,
    immediate: true,
    },
    },

  methods: {
    updateDynamicPhoneValue(value) {
      this.dynamicPhoneValue = value;
      if (this.schema && this.schema.fieldOptions) {
        this.schema.fieldOptions.dynamicPhoneValue = value;
      }
    },
    changeInput(e){
      const lastCharacter = e.data
      let qtyCharacter = this.country_id.phone_code.length
      if(qtyCharacter == 1) {
        qtyCharacter = 3
      } else if(qtyCharacter == 2) {
        qtyCharacter = 4
      } else if (qtyCharacter == 3){
          qtyCharacter = 5
      }

      const position = e.target.value.search(e.data)
      const characterValid = /^\d+$/
      const codeCountry = '+' + this.country_id.phone_code + ' '
      const codeCountryValid = e.target.value.substr(0,qtyCharacter) === codeCountry

      //if code country not wasn't changed
      if(codeCountryValid){
        if( position >= qtyCharacter   &&  characterValid.test(lastCharacter)){
          if(!characterValid.test(lastCharacter)){ //if characterValid is valid
            let onlyNumberPhone = e.target.value.substr(qtyCharacter )
            if(!characterValid.test(lastCharacter)){
              onlyNumberPhone = onlyNumberPhone.replace(lastCharacter, '')
            } else {
              onlyNumberPhone = e.target.value.substr(qtyCharacter)
            }
            this.value = '+' + this.country_id.phone_code +' -'  + onlyNumberPhone
          } else {
            this.value = e.target.value
          }
        } else {

          let onlyNumberPhone = e.target.value
          if( position >= qtyCharacter){
            if (!characterValid.test(lastCharacter)) {
              onlyNumberPhone = onlyNumberPhone.replace(lastCharacter, '') // = onlyNumberPhone.split('').filter( e => e != e.data).join('')
            }
          }
          this.value = onlyNumberPhone
        }
      } else {
        this.value = '+' + this.country_id.phone_code + ' '
      }
    },
    changeCountry(countryId){
      this.$refs.phone.focus()
      this.codeIsNew = false
      this.country_id = this.countries.find( e => e.id === countryId)
      this.value = '+' + this.country_id.phone_code +' '
    },
    countryDefault(){
      const flag = this.countries.find( el => el.id == 73).iso
      this.flagActually = require('@/assets/images/flags/' + flag +  '.svg' )
    },
    geCountries() {
      countriesService.getAll().then((result) => {
        this.countries = result.map(el => {
          return {
            ...el,
            iso: el.iso.toLowerCase(),
            visible: this.optionsDefault.includes(el.iso) ? true :false
          }
        });
        this.countriesFiltered = this.countries
        this.countryDefault();
      });
    },
  },
};
</script>

<style scoped>
.detail {
  background-color: #1f2041;
}

.logooliver {
  width: 140px;
}
.calendar {
  width: 300px;
}

.flag {
  width: 25px;
}
.flag2 {
  width: 12px;
}

.border border-dark {
  border:2px solid red
}

.icon-feature {
  width: 32px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
